import type { CountryDropdown, CultureNames } from "@repo/ui/types/cms";

import CountrySelectorClient from "./CountrySelectorClient";

export interface CountrySelectorProps {
  countryDropdown: CountryDropdown[];
  selectedCountry: CountryDropdown | null;
  cultureNames: CultureNames;
  onSelect?: () => void;
}

function CountrySelector({
  countryDropdown,
  selectedCountry,
  cultureNames,
  onSelect,
}: CountrySelectorProps) {
  return (
    <div
      data-testid="country-selector-section"
      className="cursor-pointer text-right relative z-[99]"
    >
      <CountrySelectorClient
        countryDropdown={countryDropdown}
        selectedCountry={selectedCountry}
        cultureNames={cultureNames}
        onSelect={onSelect}
      />
    </div>
  );
}

export default CountrySelector;
